<template>
  <div class="container-fluid tester-window">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Payload</label>
        <Editor v-model="payload" :textarea="true" class="ch100" />
      </div>
      <div class="col-md-4 mb-2">
        <label>Javascript</label>
        <Editor v-model="javascript" :textarea="true" class="ch100" />
      </div>
      <div class="col-md-4 mb-2">
        <label>Output</label>
        <Editor v-model="out" :textarea="true" class="ch100" />
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/API/';
import debounce from "lodash.debounce";

export default {
  name: "JSTester",
  props: {
    input: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    Editor: () => import("@/components/Editor.vue"),
  },
  computed: {
    javascript: {
      get() {
        return this.value;
      },
      set(v) {
        this.resend(v, this.pl, this);
        this.$emit("javascript-input", v);
      },
    },
    payload: {
      get() {
        return this.input;
      },
      set(v) {
        this.pl = v;
        this.resend(this.value, v, this);
      },
    },
  },
  data: () => {
    return {
      out: "",
      pl: "",
    };
  },
  methods: {
    resend: debounce((v, i, self) => {
      request.post("/editor/js", { Tr: v, In: i }).then((res) => {
        if (typeof res.data != "string") {
          self.out = JSON.stringify(res.data, undefined, " ");
        } else {
          self.out = res.data;
        }
      });
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .editor.editor__textarea {
    height: calc(100vh - 134px) !important;
  }
</style>
